export enum TenancyInterval {
  Months = 0,
  Days = 1,
}
